import { Container, FormLabel, Row } from 'react-bootstrap';
import { useSelector } from "react-redux";
import React, {useEffect} from 'react'
import UserService from './services/user.serviceaux';

export const globalinchtopointfactor = 6;
export const globalnormalopacity = 0.6;
export const globalwallx = 50;
export const globalwally = 20;

// Example usage:
// playBeep(); // Plays a default 440Hz sine wave for 200ms
// playBeep(880, 100, 'square'); // Plays an 880Hz square wave for 100ms



export const checkCollision = (newRect, existingRects) => {
  console.log("Checking collision for newRect:", newRect);  
  if (newRect.cabinetConfig.includes("placeholder")) {
    return false;
  }
  const existingRectsNoPlaceHolders = existingRects.filter(existingRect => !existingRect.cabinetConfig.includes("placeholder"));
  return existingRectsNoPlaceHolders.some(rect => {
    console.log(rect.id, newRect.id);
    if (rect.id === newRect.id) {
      return false;
    }
    else {
      console.log(newRect);
      console.log(rect);
      const isColliding = !(
        newRect.x + newRect.width <= rect.x ||     // new is left of existing
        newRect.x >= rect.x + rect.width ||        // new is right of existing
        newRect.y + newRect.height <= rect.y ||    // new is above existing
        newRect.y >= rect.y + rect.height          // new is below existing
      );      
      console.log(isColliding);   
      return isColliding;   
    }    
  });
};

export const producttypes = [
    {
        id: 1,
        producttype: "DOOR"
    },
    {
        id: 2,
        producttype: "DRAWER FRONT"
    },    
    {
        id: 3,
        producttype: "PANEL"
    },    
];

export const doorstyles = [
    {
        id: 1,
        doorstyle: "NA"
    },
    {
        id: 2,
        doorstyle: "SLAB DOOR"
    },    
    {
        id: 3,
        doorstyle: "5 PIECE SHAKER DOOR"
    },    
    {
        id: 4,
        doorstyle: "SHAKER PLUS"
    },        
]; 

export const getUserRoles = async (userId) => {
    try {
        const response = await UserService.get(userId);
        const respdata = response.data;
        //console.log(userId);
        //console.log(respdata);
        if (respdata.length > 0) {
            return (response.data[0].roles.map((a) => a.id));
        }
        else {
            return [];
        }        
    } catch (e) {
        // a type error is logged in the browser dev tools here :(
        // the cause of the error is that props.user is empty at the beginning...
        // but it doesn't seem to be affecting anything.
        // so, I think we can safely ignore it.. or not?
        //console.log(e);
        return [];
    }
};

export function dtForInputDate(dt) {
    var newDate = new Date(dt);
    var dtDate = newDate.getUTCFullYear() + '-' + (newDate.getUTCMonth()+1).toString().padStart(2,'0') + '-' + newDate.getUTCDate().toString().padStart(2,'0');    
    return dtDate;
}


export function dtFormatter(dt, type) {    
    var options;
    switch(type) {
        case 1: // Fri Dec 20 2024
            // Request a weekday along with a long date
            options = {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
            };
            // An application may want to use UTC and make that visible
            options.timeZone = "UTC";
            options.timeZoneName = "short";
            return dt.toLocaleDateString("en-US", options);

        case 2: // Fri Dec 20 2024 8:25 p.m.
            options = {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",                
                hour: "numeric",
                minute: "numeric",
                timeZone: "UTC",
                timeZoneName: "short",
            };
            return Intl.DateTimeFormat("en-US", options).format(dt);  

        case 3: // 2025-01-04 06:00:00 // To save this value in the database. 
            // Use this function when saving a date selected from an input type date
            // This way the stored value will be consistent with UTC 
            // Use the function like this: 
            // dt_to_save = dtFormatter(e.target.valueAsNumber);
            let localDate = new Date(dt);
            const now_utc = new Date(localDate.toUTCString().slice(0, -4));
            console.log(now_utc.toString());
            return now_utc.toString(); // it compensates the time zone
    }
}

export function checkIfObjectNull(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function compareItemQuantities(arr1,arr2,keyarr1,qtyarr1, keyarr2,qtyarr2) {
    // arr1 is the array of totals
    // arr2 is the array of partials
    console.log(arr1);
    console.log(arr2);

    if (arr2.length === 0) {
        return 1;
    }

    const itemMap = new Map();
    
    arr2.forEach(item => {
        itemMap.set(item[keyarr2], item[qtyarr2]);
    });
    console.log(itemMap);
    
    for (const item of arr1) {
        const correspondingQty = parseFloat(itemMap.get(item[keyarr2]));
        console.log("------");
        console.log("correspondingQty");
        console.log(isNaN(correspondingQty)?0:correspondingQty);
        const itemqty = parseFloat(item[qtyarr1]);
        console.log("itemqty");
        console.log(itemqty);        
        console.log(itemMap.get(item[keyarr1]));
        console.log(item[qtyarr1]);      
        if ((correspondingQty !== undefined) && ((isNaN(correspondingQty)?0:correspondingQty) < itemqty)) {
            return 2;
        }
    }
    return 3;
}

export function movementStatusTexts(movementType) {
    let movementTexts = {};
    switch (movementType) {
        case 1:
            movementTexts.movementName = "Purchase Order"; 
            movementTexts.statusFieldName = "postatus";
            movementTexts.sourceFieldName = "supplier.suppliername";
            movementTexts.statuses = {
                1: "Raised",
                2: "Partially received",
                3: "Received",
                4: "Paid",
                5: "Cancelled"
            };   
            break;
        case 2:
            movementTexts.movementName = "Bookin"; 
            movementTexts.statusFieldName = "bookinorbookoutstatus";
            movementTexts.sourceFieldName = "";
            movementTexts.statuses = {
                1: "Raised",
                2: "Partially returned",
                3: "Returned",
                5: "Cancelled"
            };   
            break;            
        case 3:
            movementTexts.movementName = "Bookout"; 
            movementTexts.statusFieldName = "bookinorbookoutstatus";
            movementTexts.sourceFieldName = "";
            movementTexts.statuses = {
                1: "Processed",

                5: "Cancelled"
            };   
            break;                        
        case 4:
            movementTexts.movementName = "Wastage"; 
            movementTexts.statusFieldName = "wastagestatus"; // not added yet to the table.
            movementTexts.sourceFieldName = "";
            movementTexts.statuses = {
                1: "Raised",
                2: "Partially received",
                3: "Received",
                4: "Paid",
                5: "Cancelled"
            };   
            break;            
        case 6:
            movementTexts.movementName = "Reception"; 
            movementTexts.statusFieldName = "receptionstatus";
            movementTexts.sourceFieldName = "";
            movementTexts.statuses = {
                1: "Raised",
                2: "Paid",
                5: "Cancelled"
            };   
            break;
        case 8:
            movementTexts.movementName = "Bookin Request"; 
            movementTexts.statusFieldName = "bookinrequeststatus";
            movementTexts.sourceFieldName = "job.jobtitle";
            movementTexts.statuses = {
                1: "Raised",
                2: "Partially delivered",
                3: "Delivered",
                5: "Cancelled",
            };   
            break;            
    } 
    return movementTexts;   
}


//const NewReception = (props) => {

export const NewHeader = (props) => {
    const headerTitle = props.headerTitle;
    return (
        <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', position:'sticky', top:'50px', left:'0', zIndex:'9', backgroundColor:'white', borderBottom:'1px solid gray', margin:'0', padding:'0', height:'50px', width:'100%'}}>
            <h5>
                {headerTitle}
            </h5>
        </div>  
    );
};

export const PageHeader = () => {    
    const { user: currentUser } = useSelector((state) => state.auth);	
	useEffect(() => {
		if (currentUser) {
            //console.log(currentUser);
			// these are the role ids from roles table
		}
	}, [currentUser]);  
      
    var newDate = new Date();
    var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear();
    return (
        <>
<Container style={{width:"100%", position:"fixed", top:"51px", zIndex:"5", backgroundColor:"white" }}>
            <Row className='mt-2'>
                <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>
                    
                </FormLabel>                
                <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>
                    Logged in as: {currentUser.username}, Current Date: {gtDate}
                </FormLabel>
                <p>
                    
                </p>
     
            </Row>
        </Container>
        </>
    )
}



